var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_vm._t("heading"),_vm._v(" "),_c('div',{staticClass:"section-content"},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }